/** @format */

import {useCallback, useEffect, useRef, useState} from 'react';

type TimeoutType = ReturnType<typeof setTimeout>;

interface DebounceReturn<T> {
  inputValue: T;
  onDebounceChange: (value: T) => void;
}

const useDebounceInput = <T>(defaultValue: T, time: number): DebounceReturn<T> => {
  const [inputValue, setInputValue] = useState<T>(defaultValue);

  const timeoutId = useRef<TimeoutType>();

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId.current);
    };
  }, []);

  const onDebounceChange = useCallback(
    (value: T) => {
      clearTimeout(timeoutId.current);

      timeoutId.current = setTimeout(() => {
        setInputValue(value);
      }, time);
    },
    [time],
  );

  return {
    inputValue,
    onDebounceChange,
  };
};

export {useDebounceInput};
